// extracted by mini-css-extract-plugin
export default {"section":"cases_section__W-Oyi","container":"cases_container__aHJzq","container_description":"cases_container_description__Bp6dx","button":"cases_button__SkVNM"};